import { cn } from '@/lib/cn';

interface OnboardingProgressProps {
    currentStep: number;
    totalSteps: number;
    onStepSelect: (step: number) => void;
}

/**
 * Segmented progress indicator shown above each onboarding step, with one segment per step.
 * Segments for earlier steps are buttons that return to that step.
 */
export const OnboardingProgress: React.FC<OnboardingProgressProps> = ({ currentStep, totalSteps, onStepSelect }) => (
    <ol className='flex gap-4 mt-7' aria-label={`Step ${currentStep} of ${totalSteps}`}>
        {Array.from({ length: totalSteps }, (_, index) => {
            const step = index + 1;
            const segmentClassName = cn(
                'block h-[5px] w-full rounded-full',
                step <= currentStep ? 'bg-textPrimary' : 'bg-outlinePrimary'
            );

            return (
                <li key={step} className='w-full'>
                    {step < currentStep ? (
                        <button
                            type='button'
                            className={cn(segmentClassName, 'cursor-pointer')}
                            aria-label={`Go back to step ${step}`}
                            onClick={() => onStepSelect(step)}
                        />
                    ) : (
                        <span className={segmentClassName} />
                    )}
                </li>
            );
        })}
    </ol>
);
